import type { TGamesLocaleUi } from '../en/games-ui';

export const gamesUi: TGamesLocaleUi = {
  play: 'თამაში!',
  rules: 'წესები',
  demoPlay: 'დემო თამაში',
  maxEntryFee: 'მაქს. შესვლის ფასი {{amount}}$',
  goToGameAria: 'გადასვლა — {{name}}',
  notFound: {
    title: 'თამაში ვერ მოიძებნა',
    backLink: 'უკან თამაშებზე',
  },
  moreGames: 'სხვა<accent> თამაში</accent>',
  demo: {
    title: 'დემო თამაში',
    difficulty: 'სირთულე: {{percent}}%',
    difficultyAria: 'სირთულე',
    apply: 'გამოყენება',
    player: 'შენ',
    opponent: 'ბოტი',
  },
};
